import { useEffect } from "react";
import { useRecoilValue } from "recoil";

import { useStateUnsetter } from "./../useStateUnsetter";

import { PageNames } from "@enums";
import { currentPageState } from "@states";
import {
    currentAtticsAmount,
    currentCellarsAmount,
    currentExtrasAmount,
    currentGaragesAmount,
    currentOtherAmount,
    housingTypeState,
    insuranceState,
    propertyCityState,
    propertyNumberState,
    propertyPostalCodeState,
    propertyRisk,
    propertyStreetState,
} from "@states/userData";

export function useStateListener() {
    const page = useRecoilValue(currentPageState);
    const disallowedUnsetPages = [
        PageNames.InsuranceChoice,
        PageNames.AdditionalCovers,
        PageNames.BrokerSearch,
        PageNames.YourInformation,
        PageNames.TechnicalDifficulties,
    ];

    // Unsetter hook
    const { unsetInsuranceChoiceState, unsetAdditionalCoversState } =
        useStateUnsetter();

    // Recoil values
    const housingType = useRecoilValue(housingTypeState);
    const propertyStreet = useRecoilValue(propertyStreetState);
    const propertyCity = useRecoilValue(propertyCityState);
    const propertyNumber = useRecoilValue(propertyNumberState);
    const propertyPostalCode = useRecoilValue(propertyPostalCodeState);
    const risk = useRecoilValue(propertyRisk);
    const others = useRecoilValue(currentOtherAmount);
    const attics = useRecoilValue(currentAtticsAmount);
    const garages = useRecoilValue(currentGaragesAmount);
    const cellars = useRecoilValue(currentCellarsAmount);
    const extras = useRecoilValue(currentExtrasAmount);
    const chosenInsurance = useRecoilValue(insuranceState);

    // Listeners
    useEffect(() => {
        if (
            page &&
            (!disallowedUnsetPages.includes(page.name as PageNames) ||
                page.name === PageNames.InsuranceChoice)
        ) {
            unsetAdditionalCoversState();
        }

        // eslint-disable-next-line
    }, [chosenInsurance]);

    useEffect(() => {
        if (page && !disallowedUnsetPages.includes(page.name as PageNames))
            unsetInsuranceChoiceState();
        // eslint-disable-next-line
    }, [
        housingType,
        propertyStreet,
        propertyCity,
        propertyNumber,
        propertyPostalCode,
        risk,
        others,
        attics,
        garages,
        cellars,
        extras,
    ]);
}
